import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { executiveMetrics } from '../../data/content';

const ExecutiveMetrics = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {executiveMetrics.map((metric, idx) => (
        <motion.div
          key={idx}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: idx * 0.1 }}
          className="bg-white dark:bg-slate-900 rounded-2xl p-6 shadow-xl border border-slate-100 dark:border-slate-800 group hover:border-brand-cyan transition-all"
        >
          <div className="flex justify-between items-start mb-4">
            <span className="text-[10px] uppercase font-bold tracking-widest text-slate-500 dark:text-slate-400">
              {metric.label}
            </span>
            <div className={`p-1.5 rounded-md ${metric.trend === 'up' ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'}`}>
              <SafeIcon name={metric.trend === 'up' ? "ArrowUpRight" : "ArrowDownRight"} className="w-3 h-3" />
            </div>
          </div>
          <p className="text-3xl font-heading font-black text-slate-900 dark:text-white mb-1">
            {metric.value}
          </p>
          <p className="text-[10px] text-slate-400 font-medium">
            {metric.period}
          </p>
        </motion.div>
      ))}
    </div>
  );
};

export default ExecutiveMetrics;